import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

const DeleteConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmButtonText,
  cancelButtonText,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-confirmation-title"
      aria-describedby="delete-confirmation-description"
    >
      <DialogTitle id="delete-confirmation-title">{title}</DialogTitle>
      <DialogContent>
        <SoftTypography id="delete-confirmation-description">
          {description}
        </SoftTypography>
      </DialogContent>
      <DialogActions>
        <SoftButton onClick={onClose} color="secondary">
          {cancelButtonText}
        </SoftButton>
        <SoftButton onClick={onConfirm} color="error">
          {confirmButtonText}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};

DeleteConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
};

export default DeleteConfirmationDialog;
